import { useMediaQuery, useTheme } from "@material-ui/core";
import { Breakpoint } from "@material-ui/core/styles/createBreakpoints";

export function useBreakpoint(): Breakpoint {
  const theme = useTheme();

  const breakPointsMatches = [
    { breakpoint: "xs", matches: useMediaQuery(theme.breakpoints.down("xs")) },
    { breakpoint: "sm", matches: useMediaQuery(theme.breakpoints.down("sm")) },
    { breakpoint: "md", matches: useMediaQuery(theme.breakpoints.down("md")) },
    { breakpoint: "lg", matches: useMediaQuery(theme.breakpoints.down("lg")) },
    { breakpoint: "xl", matches: useMediaQuery(theme.breakpoints.down("xl")) },
  ];

  const firstMatch = breakPointsMatches.find((m) => m.matches);

  return (firstMatch?.breakpoint || "xl") as Breakpoint;
}
